import React, { useEffect, useState } from "react";
import HeadBar from "../../../components/Static/HeadBar";
import FormButton from "../../../components/Buttons/FormButton";
import { useDispatch, useSelector } from "react-redux";
import { setLead, setOffers } from "../../../store/app/appReducer";
import callApi from "../../../utility/apiCaller";
import OfferTile from "../../PersonalDetails/components/OfferTile";
import { setUserClickData } from "../../../utility/setUserClickData";
import { useSearchParams } from "react-router-dom";

const OfferDetailsSegment = () => {
  const dispatch = useDispatch();
  // const lead = useSelector((state) => state.app.lead);
  const user = useSelector((state) => state.app.user);
  const offers = useSelector((state) => state.app.offers);
  const [isFinished, setIsFinished] = useState(false);
  const [show, setShow] = useState(false);
  const [source, setSource] = useState("");
  const [leadId, setLeadId] = useState();
  const [activeLenders, setActiveLenders] = useState([]);
  const [contactName, setContactName] = useState("Dear Customer");
  const [params] = useSearchParams();

  useEffect(() => {
    if (params.get("lid")) setLeadId(params.get("lid"));
    if (params.get("source")) setSource(params.get("source"));
  }, [params]);

  useEffect(() => {
    if(leadId) {
      fetchOffers();
      const timer = setInterval(() => {
        if (leadId) fetchOffers();
      }, 5000);
    
      return () => clearInterval(timer);
    }
  }, [leadId]);

  useEffect(() => {
    fetchActiveLenders();
  }, []);

  const fetchActiveLenders = async () => {
    try {
      const res = await callApi(
        `v1/lender/active-lenders`,
        "get",
        {},
        "loan"
      );
      if (res.status === "Success") {
        setActiveLenders(res.data.lenderList ?? []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchOffers = async () => {
    // console.log("Fetch Offers Triggered. isFinished:", isFinished);
    if (isFinished) return;
  
    try {
      const res = await callApi(
        `v1/loan_offer/lead_id/${leadId}`,
        "get",
        {},
        "core",
      );

      if (res.status === "Success") {
        let filteredOffers = res.data.offers ?? [];
        // console.log("Original Offers from API:", res.data.offers);

        // filteredOffers = filteredOffers.filter((offer) =>
        //   activeLenders.some((lender) => lender._id === offer.lender_id)
        // );
        filteredOffers = activeLenders.length
        ? filteredOffers.filter((offer) =>
            activeLenders.some((lender) => lender._id === offer.lender_id)
          )
        : filteredOffers;

        // console.log("Filtered Offers:", filteredOffers);

        dispatch(setOffers(filteredOffers));

        const leadName = res.data.lead?.contact_name;
        setContactName(leadName || "Dear Customer")
        // console.log("All Response:" , res.data.lead?.all_responses);
        // console.log("Total Response:" , res.data.lead?.total_response);

        if (filteredOffers.length > 0) {
          setIsFinished(true);
        } else if (res.data.lead?.all_responses > 0) {
          const responseCount = res.data.lead?.all_responses === res.data.lead?.total_response;
          setIsFinished(responseCount);

          if (responseCount) {
            setIsFinished(true);
            setUserClickData({
              event_name: "no-respone-found-v2",
              user_id: leadId || "unknown",
            });
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handelShow = () => {
    setShow(true);
    setUserClickData({ event_name: "view-more-check-offers-v2" });
  };

  return (
    <div className={"form-signin-apply form-signin"}>
      <HeadBar />
      {!isFinished && offers?.length === 0 && (
        <div className="mb-4 font-normal text-center">
          Please wait while we are searching best offers for you
          <span className="ml-2 dot-pulse"></span>
        </div>
      )}
      {isFinished && offers?.length === 0 && (
        <div className="mb-4 font-normal text-center">
          There is no offer for you currently.
        </div>
      )}
      {offers?.length > 0 && (
        <div className="flex flex-col items-center justify-center">
          <img src="/assets/img/Dm LOGO.png" />

          <h3 className="mt-8 text-lg text-center">
            Congratulations{" "}
            <span className="text-2xl font-normal">{contactName} !!</span>{" "}
          </h3>
          <h3 className="text-lg">Your pre-approved offers </h3>

          {offers.length > 1 ? (
            <div className="px-10 py-1 mt-4 text-xs font-semibold bg-gray-300 rounded">
              RECOMMENDED
            </div>
          ) : null}
          {[...offers]
            .sort((a, b) => parseInt(a.priority) - parseInt(b.priority))
            .slice(0, 1)
            .map((e) => (
              <div key={e._id} className="my-4">
                <OfferTile 
                  small={false} 
                  offer={e} 
                  source={source} 
                  eventName="offer-apply-button-v2" 
                  userId={user?.phone_number}
                />
              </div>
            ))}
          <div
            className={
              "grid gap-4" +
              (offers.length === 2
                ? " grid-cols-1"
                : offers.length === 3
                ? " grid-cols-2"
                : " grid-cols-3")
            }
          >
            {[...offers]
              .sort((a, b) => parseInt(a.priority) - parseInt(b.priority))
              .slice(1, show ? 1000 : 4)
              .map((e) => (
                <div key={e._id} className="">
                  <OfferTile 
                    small
                    offer={e} 
                    source={source} 
                    eventName="offer-apply-button-v2" 
                    userId={user?.phone_number}
                  />
                </div>
              ))}
          </div>

          {offers.length > 4 && !show && (
            <div>
              <FormButton onClick={handelShow} className="!mt-12 !w-40">
                View more
              </FormButton>
            </div>
          )}

          {!isFinished && (
            <div className="mt-4 font-normal text-center">
              Please wait while we are searching best offers for you
              <span class="ml-2 dot-pulse"></span>
            </div>
          )}

          <h4 className="mt-4 text-xs text-center">
            *These pre-approved offers are subject to change at discretion of
            Bank / NBFC after receiving all your documents and details. Final
            offer will be based on risk policy of Bank / NBFC. We do not
            guarantee that final offer will be same as Pre-approved offer.
          </h4>
        </div>
      )}
    </div>
  );
};

export default OfferDetailsSegment;
